import axios from 'axios';

// Via proxy /locale para o token findip.net ficar no servidor; não chame a API direto.
const apiFindIp = axios.create({
  baseURL: '/locale',
  withCredentials: true,
});

apiFindIp.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/';
      localStorage.removeItem('user');
    }
    return Promise.reject(error);
  }
);

export default apiFindIp;
